const isEmail = (email) => {
  if (!email) return required(email);
  if (/.+@.+\..+/.test(email)) return true
  return 'Email must be valid!'
}

const required = (text) => {
  if (text) return true
  return 'This field is required!'
}

const isPasswordValid = (pass) => {
  if (pass.length < 8) {
    return 'Min. 8 characters'
  }

  if (!/[a-z]/.test(pass)) {
    return 'Please include lowercase letter.'
  }

  if (!/[A-Z]/.test(pass)) {
    return 'Please include uppercase letter.'
  }

  if (!/\d/.test(pass)) {
    return 'Please include number.'
  }

  return true
}

export { required, isEmail, isPasswordValid }